import {FC, useState} from 'react'
import {storeBooking} from "../../lib/booking";
import {formatSlug} from "../../lib/helpers";

interface Props {
    booking:Booking,
    setBooking:Function,
    item:any
}

const Remove: FC<Props> = ({booking, setBooking, item}) => {

    const remove = () => {
        // Remove option hjulskifte tire offer
        if(booking.hjulskifte.options === item) {
            booking.hjulskifte.options.product_id = null
            booking.hjulskifte.options.name = null
            booking.hjulskifte.options.quantity = null
            booking.hjulskifte.options.price = null
        }

        // Remove option tire shop
        for(let i=0; i<booking.tire_shop.length; i++){
            if(booking.tire_shop[i] === item)
               delete booking.tire_shop[i]
        }

        // Remove option woo product
        for(let i=0; i<booking.options.length; i++){
            if(booking.options[i] === item)
                booking.options.splice(i, 1);
        }

        storeBooking(booking, setBooking)
    }

    return (
        <span className={'option-remove'} onClick={e => remove()}>
            <i className="far fa-times-circle" aria-hidden="true"/>
        </span>
    )
};

export default Remove